import React, { useEffect, useState } from "react";
import axios from "axios";
import { DataTable } from "mha-ui-kit-react-library/dist/index";
import { LoadingSpinner } from "./../../layout/LoadingSpinner";
import { Modal } from "react-bootstrap";
import StatusModal from "../../StatusModal";
import useStatusModal from "../../../hooks/useStatusModal";

const ContactsModal = (props) => {
  const { id, type, show, handleImpersonateClick } = props;

  const [contactsLoaded, setContactsLoaded] = useState(false);
  const [contactsData, setContactsData] = useState([]);

  const { statusProps, handleErrorStatus } = useStatusModal();

  useEffect(() => {
    if (id != null && type != null && !contactsLoaded) {
      const uri = `api/members/contacts?id=${id}&locType=${type}`;

      console.log("contacts modal - api call", uri);
      axios.get(uri).then(
        (result) => {
          setContactsLoaded(true);
          setContactsData(result.data);
        },
        (error) => {
          console.error(error.message);
          handleErrorStatus("An error occurred retrieving the contacts data.");
          setContactsLoaded(true);
        }
      );
    }
  }, [id, type, contactsLoaded]);

  const handleClose = () => {
    setContactsLoaded(false);
    props.handleClose();
  };

  const contactsColumns = [
    {
      title: "Impersonate",
      accessor: "",
      transform: (value, index, row) => {
        return (
          <button
            className="link-button no-focus"
            onClick={() => handleImpersonateClick(row)}
          >
            Impersonate
          </button>
        );
      },
    },
    {
      title: "First Name",
      accessor: "FirstName",
    },
    {
      title: "Last Name",
      accessor: "LastName",
    },
    {
      title: "Job Title",
      accessor: "JobTitle",
    },
    {
      title: "Email",
      accessor: "Email",
    },
  ];

  const ContactsTable = () => {
    if (!contactsLoaded) {
      return (
        <React.Fragment>
          <LoadingSpinner isDataLoading="true" />
          <DataTable
            id="tblContacts"
            columns={contactsColumns}
            handleCellClick={() => {}}
          />
        </React.Fragment>
      );
    } else {
      return (
        <DataTable
          id="tblContacts"
          rows={contactsData}
          columns={contactsColumns}
          filterable
          pagination
              handleCellClick={() => { }}
              freezeheader
        />
      );
    }
  };

  return (
    <React.Fragment>
      <StatusModal statusProps={statusProps} />
      <Modal
        show={show}
        onHide={() => handleClose()}
        dialogClassName="modal-90w"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Impersonate Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactsTable />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ContactsModal;
